/* eslint-disable react/no-string-refs */
import React, { Component } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import cx from "clsx";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import InboxSidebar from "../InboxSidebar.js";
import Loader from "../../Common/Loader.js";
import {
  fetchInboxChat,
  fetchSMSNotificationsPopups,
  createReply,
  exportEmptyData,
} from "../../../Actions/Inbox/inboxAction.js";
import { fetchNotificationsPopupsMenu } from "../../../Actions/Dashboard/dashboardActions";
import {
  numberFormat,
  displayName,
  getCurrencySymbol,
  showFormattedDate,
  getTimeFormat,
} from "../../../Utils";
import { findBadWordsIn } from "../../../utilities/general.js";
import classes from "./CreateSMS.module.scss";
import { AppTranslation, tCommon } from "../../../i18n/useAppTranslation.js";
import { history } from "../../../history.js";
import { AlertBox } from "../../../shared/AlertBox/AlertBox.js";
import { uiNotification } from "../../../services/UINotificationService.js";
import { withCurrentUserQuery } from "../../../api/queries/useUserQuery.js";
import { ButtonFollowLink } from "../../../shared/ButtonFollowLink/ButtonFollowLink.js";
import { MessageTextarea } from "./components/MessageTextarea";

const MESSAGE_MAX_LEN = 1000;

const MESSAGES = {
  message_body_limit_exceeded: "Message limit exceeded",
};

const getInboxChatPatient = (data = {}) => {
  if (data.patient) {
    return data.patient;
  }

  return data.notification?.patient ? data.notification.patient : {};
};

const getInboxChatNotifications = (data = {}) => {
  if (Array.isArray(data.notifications)) {
    return data.notifications;
  }

  return Array.isArray(data.all_notifications) ? data.all_notifications : [];
};

const getInboxChatTimeFormat = (data = {}) => {
  return data.time_format || "";
};

const getInboxChatLastVisit = (patient, fallback) => {
  return patient?.last_activity ? patient.last_activity : fallback;
};

const getInboxChatFallbackPatientName = (data = {}) => {
  if (data.patient?.full_name) {
    return data.patient.full_name;
  }

  if (data.notification?.first_name) {
    return `${data.notification.first_name} ${data.notification.last_name}`;
  }

  const notifications = getInboxChatNotifications(data);

  if (notifications.length && notifications[0].from_number) {
    return notifications[0].from_number;
  }

  return data.notification?.from_number || null;
};

const getInboxChatAvatarUrl = (entity) => {
  return entity?.user_image_url || "";
};

const getInboxChatInitials = (entity) => {
  const fullName = entity?.full_name || "";

  if (fullName) {
    return fullName
      .split(" ")
      .map((namePart) => namePart.charAt(0).toUpperCase())
      .join("");
  }

  return entity?.firstname
    ? `${entity.firstname.charAt(0).toUpperCase()}${
        entity.lastname ? entity.lastname.charAt(0).toUpperCase() : ""
      }`
    : "";
};

const getInboxChatMessageName = (notification, entityKey, fallbackKey) => {
  const entity = notification[entityKey];

  if (entity?.full_name) {
    return `${entity.full_name},`;
  }

  return notification[fallbackKey];
};

class CreateSMS extends Component {
  constructor(props) {
    super(props);
    const userData = JSON.parse(localStorage.getItem("userData"));
    const languageData = JSON.parse(localStorage.getItem("languageData"));
    let inboxClinicId = localStorage.getItem("inboxClinicId")
      ? localStorage.getItem("inboxClinicId")
      : -1;
    this.state = {
      languageData: languageData.clients,
      globalLang: languageData.global,
      timezone: "",
      city: "",
      php_timezone: "",
      country_name: "",
      country_code: "",
      defaultCountry: "us",
      clinic_name: "",
      contact_no: "",
      email_special_instructions: "",
      sms_notifications_phone: "",
      smsPopupData: [],
      defaultImg: "/images/user.png",
      reply: "",
      tax: "",
      time_format: "",
      clinicData: {},
      userId: userData.user.id,
      id: this.props.match.params.id,
      page: 1,
      pagesize: 15,
      sortorder: "asc",
      term: "",
      hasMoreItems: true,
      next_page_url: "",
      loadMore: true,
      startFresh: true,
      showLoader: false,
      scopes: "business_hours",
      user_changed: false,
      timezoneList: [],
      countryList: [],
      notiEmailArr: [],
      multipleEmailClass: "setting-input-box notiEmailInput",
      contactClass: "setting-input-box",
      notiContactClass: "setting-input-box",
      inboxClinicId: inboxClinicId,
      fallbackPatientName: "",
      last_visit: "",
      patientData: {},
    };
  }
  scrollbarRef = React.createRef();

  componentDidMount() {
    const patientId = this.props.match.params.id;
    const phoneNumber = this.props.match.params.phoneNumber;
    let languageData = JSON.parse(localStorage.getItem("languageData"));
    this.setState({
      phoneNumber: phoneNumber != undefined ? phoneNumber : undefined,
      SMS_Notifications_popup:
        languageData.dashboard["SMS_Notifications_popup"],
      SMS_Notifications_popup_IM_History:
        languageData.dashboard["SMS_Notifications_popup_IM_History"],
      edit_clinic_subheader: languageData.settings["edit_clinic_subheader"],
      edit_clinic_Clinic_name: languageData.settings["edit_clinic_Clinic_name"],
      edit_clinic_contact_no: languageData.settings["edit_clinic_contact_no"],
      edit_clinic_time_zone: languageData.settings["edit_clinic_time_zone"],
      edit_clinic_address: languageData.settings["edit_clinic_address"],
      edit_clinic_city_state: languageData.settings["edit_clinic_city_state"],
      edit_clinic_country: languageData.settings["edit_clinic_country"],
      edit_clinic_notif_email: languageData.settings["edit_clinic_notif_email"],
      edit_clinic_sms_notif_phone:
        languageData.settings["edit_clinic_sms_notif_phone"],
      edit_clinic_sms_multiple_emails:
        languageData.settings["edit_clinic_sms_multiple_emails"],
      edit_clinic_tax_settings:
        languageData.settings["edit_clinic_tax_settings"],
      edit_clinic_tax_rate: languageData.settings["edit_clinic_tax_rate"],
      edit_clinic_business_hours:
        languageData.settings["edit_clinic_business_hours"],
      edit_clinic_open_hours: languageData.settings["edit_clinic_open_hours"],
      edit_clinic_close_hours: languageData.settings["edit_clinic_close_hours"],
      edit_clinic_monday: languageData.settings["edit_clinic_monday"],
      edit_clinic_tuesday: languageData.settings["edit_clinic_tuesday"],
      edit_clinic_wednesday: languageData.settings["edit_clinic_wednesday"],
      edit_clinic_thursday: languageData.settings["edit_clinic_thursday"],
      edit_clinic_friday: languageData.settings["edit_clinic_friday"],
      edit_clinic_Saturday: languageData.settings["edit_clinic_Saturday"],
      edit_clinic_sunday: languageData.settings["edit_clinic_sunday"],
      edit_clinic_delete_button:
        languageData.settings["edit_clinic_delete_button"],
      clinic_delete_warning: languageData.settings["clinic_delete_warning"],
      yes_option: languageData.settings["yes_option"],
      no_option: languageData.settings["no_option"],
      delete_confirmation: languageData.global["delete_confirmation"],
      editUsers_CancelBtn: languageData.settings["editUsers_CancelBtn"],
    });
    this.setState({ showLoader: true });

    if (patientId) {
      this.props.fetchSMSNotificationsPopups({
        params: {
          mode: "add",
          id: patientId,
        },
      });
    } else {
      this.props.fetchInboxChat(phoneNumber);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const objDiv = document.getElementById("main-chat-outer");
    if (objDiv) {
      objDiv.scrollTop = objDiv?.scrollHeight ? objDiv.scrollHeight : 0;
    }
    if (this.state.patientData) {
      const objDiv2 = document.getElementById("main-chat-outer-2");
      if (objDiv2) {
        objDiv2.scrollTop = objDiv2?.scrollHeight ? objDiv2.scrollHeight : 0;
      }
    }
    if (
      prevProps.smsPopupDataTime &&
      prevState.smsPopupData.length &&
      this.scrollbarRef
    ) {
      this.scrollbarRef.current.scrollToBottom();
    }
  }

  static getDerivedStateFromProps(props, state) {
    let returnState = {};
    if (props.showLoaderTime != state.showLoaderTime) {
      returnState.showLoaderTime = props.showLoaderTime;
      returnState.showLoader = false;
    }
    if (
      props.smsPopupData !== undefined &&
      props.smsPopupDataTime != state.smsPopupDataTime
    ) {
      const smsPopupData = props.smsPopupData.data || {};
      const patient = getInboxChatPatient(smsPopupData);

      returnState.smsPopupDataTime = props.smsPopupDataTime;
      returnState.showLoader = false;
      returnState.time_format = getInboxChatTimeFormat(smsPopupData);
      returnState.smsPopupData = getInboxChatNotifications(smsPopupData);
      returnState.patientData = patient;
      returnState.last_visit = getInboxChatLastVisit(patient, state.last_visit);
      returnState.fallbackPatientName =
        getInboxChatFallbackPatientName(smsPopupData);
      props.exportEmptyData();
      props.fetchNotificationsPopupsMenu({ force: true });
    }
    return returnState;
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const patientId = this.props.match.params.id;
    const phoneNumber = this.props.match.params.phoneNumber;

    const badWords = findBadWordsIn(this.state.reply || "");

    if (badWords.length > 0) {
      return uiNotification.error(tCommon("error.badWords"));
    }

    let formData = {
      id: patientId ? 0 : phoneNumber,
      reply: this.state.reply,
      mode: patientId ? "add" : "edit",
    };

    if (patientId) {
      formData.patient_id = patientId;
    }

    this.setState({ showLoader: true });

    this.props
      .createReply(formData, this.props.match.params.id)
      .then(() => {
        this.setState({
          reply: "",
        });
      })
      .catch((res) => {
        uiNotification.error(
          this.state.globalLang[res.message] ||
            MESSAGES[res.message] ||
            res.message,
        );
      })
      .finally(() => {
        this.setState({ showLoader: false });
      });

    if (typeof this.refs?.reply === "object" && this.refs?.reply !== null) {
      this.refs.reply.value = "";
    }
  };

  validateForm() {
    return this.state.reply.length > 0;
  }

  getPreviewDateFormat = () => {
    const currentUserData =
      this.props.currentUserQuery && this.props.currentUserQuery.data
        ? this.props.currentUserQuery.data
        : {};

    return currentUserData.previewDateFormat;
  };

  renderChatMessage = (notification, settings) => {
    const entity = notification[settings.entityKey];
    const imgUrl = getInboxChatAvatarUrl(entity);
    const message =
      notification.message_type === settings.messageType
        ? notification.message
        : "";
    const pictureStyle = {
      backgroundImage: "url(" + imgUrl + ")",
      backgroundColor: "#dddddd",
    };

    return (
      <div
        className={
          notification.message_type === settings.messageType
            ? settings.wrapperClass + " chat-div"
            : "no-display"
        }
        data-notty-id={settings.nottyId}
      >
        {imgUrl ? (
          <div className="sms-user-picture" style={pictureStyle} />
        ) : (
          <div className="sms-user-picture">{getInboxChatInitials(entity)}</div>
        )}

        <div className="chat-name ">
          {getInboxChatMessageName(
            notification,
            settings.entityKey,
            settings.fallbackKey,
          )}{" "}
          <div className="chat-time">
            {showFormattedDate(
              notification.created,
              JSON.stringify(notification.created),
              settings.timeFormat,
            )}
          </div>
        </div>
        <div className={cx("chat-txt-gray", settings.messageClass)}>
          {message}
        </div>
      </div>
    );
  };

  render() {
    const isDoNotSms = Boolean(this.state.patientData?.do_not_sms);
    this.state.languageData &&
    this.state.languageData.clientprofile_del_client_message
      ? this.state.languageData.clientprofile_del_client_message
      : "";

    let height = window.innerHeight - 215;

    const { patientData } = this.state;
    const patientName = patientData.full_name || displayName(patientData);
    let membershipBenefits = patientData.membership_benefits_this_year;

    let membership_saving =
      getCurrencySymbol() + (membershipBenefits || "0.00");

    let membership_type =
      patientData.is_monthly_membership == 1 ? "Registered" : "Not Registered";

    let timeFormat = getTimeFormat();
    return (
      <div id="content">
        <div className="container-fluid content setting-wrapper">
          <InboxSidebar inboxClinicId={this.state.inboxClinicId} />

          <div className="memberWalletOuter business-section">
            <div className="setting-setion m-b-10">
              <div className="membership-title">
                {patientName || this.state.fallbackPatientName}
                <div className="memberRightActions">
                  {this.state.patientData?.phoneNumber || ""}
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-7">
                <div className="setting-setion m-b-15">
                  <div
                    className={cx("main-chat-outer", {
                      "p-b-60": isDoNotSms,
                    })}
                    id="main-chat-outer"
                    style={{ height: `${height}px` }}
                  >
                    <Scrollbars
                      ref={this.scrollbarRef}
                      className="messages-list full-width"
                      renderTrackHorizontal={(props) => (
                        <div
                          {...props}
                          style={{ display: "none" }}
                          className="track-horizontal"
                        />
                      )}
                    >
                      {this.state.smsPopupData?.map((obj, idx) => {
                        let displayDate;
                        let todaysDate = new Date();
                        let getTodaysDate = todaysDate.getDate();

                        if (obj.created === getTodaysDate) {
                          displayDate = getTodaysDate;
                        } else {
                          displayDate = obj.created;
                        }

                        return (
                          <div key={idx}>
                            <div
                              className={
                                getTodaysDate !== obj.created
                                  ? "date-divider"
                                  : "no-display"
                              }
                            >
                              <span className="chat-date">
                                {showFormattedDate(
                                  displayDate,
                                  false,
                                  this.getPreviewDateFormat(),
                                )}
                              </span>
                            </div>
                            {this.renderChatMessage(obj, {
                              entityKey: "patient",
                              fallbackKey: "from_number",
                              messageType: "message",
                              nottyId: 146,
                              timeFormat: timeFormat,
                              wrapperClass: "left-chat-outer",
                            })}
                            {this.renderChatMessage(obj, {
                              entityKey: "user",
                              fallbackKey: "to_number",
                              messageClass: classes.chatMessage,
                              messageType: "reply",
                              nottyId: 147,
                              timeFormat: timeFormat,
                              wrapperClass: "right-chat-outer",
                            })}
                          </div>
                        );
                      })}
                    </Scrollbars>

                    {isDoNotSms ? (
                      <div className="type-message p-0">
                        <AlertBox size="small">
                          You cannot send a message because of patient DND
                          settings
                        </AlertBox>
                      </div>
                    ) : (
                      <div className="type-message">
                        <form
                          id="reply"
                          name="reply-form"
                          action="#"
                          method="post"
                          onSubmit={this.handleSubmit}
                          className={cx("h-auto", classes.replyForm)}
                        >
                          <MessageTextarea
                            maxLength={MESSAGE_MAX_LEN}
                            value={this.state.reply}
                            onChange={(value) =>
                              this.setState({ reply: value, userChanged: true })
                            }
                          />
                          <input
                            value="Send"
                            type="submit"
                            className={
                              !this.validateForm()
                                ? "header-select-btn reply-btn disable"
                                : "header-select-btn reply-btn"
                            }
                            disabled={!this.validateForm()}
                          />
                        </form>
                        <div className={classes.msgLimit}>{`${
                          (this.state.reply || "").length
                        } / ${MESSAGE_MAX_LEN}`}</div>
                        <div className={classes.inputDescription}>
                          <AppTranslation.Settings path="smsSnippets.inputDescription" />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="patient-left merge-info">
                  <div className="merge-setion">
                    <div className="section-title header-blue">
                      <div className={classes.patientName}>
                        <span>
                          {patientName || this.state.fallbackPatientName}
                        </span>
                        {this.state.patientData?.id && (
                          <ButtonFollowLink
                            url={`/clients/profile/${this.state.patientData.id}`}
                            leave={true}
                          />
                        )}
                      </div>
                    </div>

                    {patientName && (
                      <div
                        id="main-chat-outer-2"
                        style={{ height: `${height - 50}px` }}
                      >
                        <Scrollbars
                          style={{ minHeight: `${height - 51}px` }}
                          className="full-width"
                          renderTrackHorizontal={(props) => (
                            <div
                              {...props}
                              style={{ display: "none" }}
                              className="track-horizontal"
                            />
                          )}
                        >
                          <div className="pro-pic-outer clientChatPicOuter">
                            <img
                              alt="User"
                              src={
                                this.state.patientData?.user_image_url
                                  ? this.state.patientData.user_image_url
                                  : "/images/user.png"
                              }
                            />
                            <div className="profile-img-info">
                              {this.state.patientData?.email && (
                                <h5 className="break-word-content clientChatInfo">
                                  <i className="fa fa-envelope"></i>{" "}
                                  {this.state.patientData?.email}
                                </h5>
                              )}
                              {(this.state.patientData?.address_line_1 ||
                                this.state.patientData?.address_line_2 ||
                                this.state.patientData?.city ||
                                this.state.patientData?.state ||
                                this.state.patientData?.pincode) && (
                                <h5 className="break-word-content clientChatInfo m-b-0">
                                  <i className="fa fa-map-marker"></i>
                                  {this.state.patientData?.address_line_1 && (
                                    <div>
                                      {this.state.patientData?.address_line_1},{" "}
                                      <br />
                                    </div>
                                  )}
                                  {this.state.patientData?.address_line_2 && (
                                    <div>
                                      {this.state.patientData?.address_line_2},{" "}
                                      <br />
                                    </div>
                                  )}
                                  {this.state.patientData.city && (
                                    <span>{this.state.patientData.city},</span>
                                  )}{" "}
                                  {this.state.patientData.state && (
                                    <span>{this.state.patientData.state}</span>
                                  )}{" "}
                                  {this.state.patientData.pincode && (
                                    <span>
                                      {this.state.patientData.pincode}
                                    </span>
                                  )}
                                </h5>
                              )}
                            </div>
                          </div>

                          <div className="about-form ChatInfoRowContainer">
                            <div className="ChatInfoRow">
                              <label>
                                {this.state.languageData.clientprofile_birthday}{" "}
                                :
                              </label>{" "}
                              <span>
                                {this.state.showLoader === false &&
                                this.state?.patientData?.date_of_birth
                                  ? showFormattedDate(
                                      this.state.patientData.date_of_birth,
                                      false,
                                      this.props.currentUserQuery?.data
                                        ?.previewDateFormat,
                                    )
                                  : ""}
                              </span>
                            </div>
                            <div className="ChatInfoRow">
                              <label>
                                {
                                  this.state.languageData
                                    .clientprofile_emergency_name
                                }{" "}
                                :
                              </label>{" "}
                              <span>
                                {this.state.patientData
                                  ?.emergency_contact_name !== ""
                                  ? this.state.patientData
                                      .emergency_contact_name
                                  : ""}
                              </span>
                            </div>
                            <div className="ChatInfoRow">
                              <label>
                                {
                                  this.state.languageData
                                    .clientprofile_emergency_number
                                }{" "}
                                :
                              </label>{" "}
                              <span>
                                {this.state.patientData
                                  ?.emergency_contact_number !== ""
                                  ? this.state.patientData
                                      .emergency_contact_number
                                  : ""}
                              </span>
                            </div>
                            <div className="ChatInfoRow">
                              <label>
                                {
                                  this.state.languageData
                                    .clientprofile_last_visit
                                }{" "}
                                :
                              </label>{" "}
                              <span>
                                {" "}
                                {this.state.last_visit
                                  ? showFormattedDate(
                                      this.state.last_visit,
                                      false,
                                      this.props.currentUserQuery?.data
                                        ?.previewDateFormat,
                                    )
                                  : "Never"}
                              </span>
                            </div>
                            <div className="ChatInfoRow">
                              <label>
                                {
                                  this.state.languageData
                                    .clientprofile_membership_program
                                }{" "}
                                :
                              </label>{" "}
                              <span>{membership_type} </span>
                            </div>
                            {membership_type === "Registered" && (
                              <div className="ChatInfoRow">
                                <label>
                                  {
                                    this.state.globalLang
                                      .label_membership_savings
                                  }{" "}
                                  :{" "}
                                </label>{" "}
                                <span>{membership_saving}</span>
                              </div>
                            )}
                            <div className="ChatInfoRow">
                              <label>
                                {
                                  this.state.languageData
                                    .clientprofile_sale_relation
                                }{" "}
                                :
                              </label>{" "}
                              <span>
                                {" "}
                                {this.state?.patientData
                                  ?.total_sale_relationship > 0
                                  ? numberFormat(
                                      this.state.patientData
                                        .total_sale_relationship,
                                      "currency",
                                    )
                                  : numberFormat(0, "currency")}
                              </span>
                            </div>
                          </div>
                        </Scrollbars>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Loader showLoader={this.state.showLoader} isFullWidth={true} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const languageData = JSON.parse(localStorage.getItem("languageData"));
  const returnState = {};

  uiNotification.clear();
  if (
    state.InboxReducer.action === "SELECTED_SMS_POPUPS" ||
    state.InboxReducer.action === "FETCH_INBOX_CHAT"
  ) {
    if (state.InboxReducer.data.status === 200) {
      returnState.smsPopupData = state.InboxReducer.data;
      returnState.smsPopupDataTime = new Date();
    } else if (state.InboxReducer.data.message === "patient_is_blacklisted") {
      setTimeout(() => {
        uiNotification.error("Phone number is blacklisted");
      }, 0);
      history.replace("/inbox/sms/all");
    } else {
      uiNotification.error(
        languageData.global[state.InboxReducer.data.message],
      );
      returnState.showLoaderTime = new Date();
    }
  }
  if (state.InboxReducer.action === "CREATE_REPLY_INBOX") {
    if (state.InboxReducer.data.status === 200) {
      returnState.smsPopupData = state.InboxReducer.data;
      returnState.smsPopupDataTime = new Date();
    }
  }
  return returnState;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchSMSNotificationsPopups: fetchSMSNotificationsPopups,
      fetchInboxChat: fetchInboxChat,
      createReply: createReply,
      fetchNotificationsPopupsMenu: fetchNotificationsPopupsMenu,
      exportEmptyData: exportEmptyData,
    },
    dispatch,
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(withCurrentUserQuery(CreateSMS)));
